
import { create } from "zustand";
import { API_BASE_URL1, API_BASE_URL } from "../../../Services/baseApiUrl";
import { apiCall } from "../../../../utils/apiCall";

const CommonApiStore = create((set, get) => ({

    commonReportsData: [],
    loading: false,
    error: false,

    fetchAllCommonReportsApi: async (collectionTypeId,fromDate,toDate,zoneId,vehicleNumber,vehicleTypeIds) => {
        set({ loading: true, error: null });
        try {
            // Build query params
            // let url = `${API_BASE_URL}api/SecondaryCollection/UnifiedWasteCollectionTransportationReport?CollectionPointTypeId=${collectionTypeId}&FromDate=${fromDate}&ToDate=${toDate}&ZoneId=${zoneId}&vehcileNumber=${vehicleNumber}`;
            let url = `${API_BASE_URL}api/SecondaryCollection/UnifiedWasteCollectionTransportationReport?CollectionPointTypeId=${collectionTypeId}&FromDate=${fromDate}&ToDate=${toDate}&ZoneId=${zoneId}&vehcileNumber=${vehicleNumber}`;
            // Add vehicle type filter if provided
            if (vehicleTypeIds && vehicleTypeIds.length > 0) {
                url += `&vehicleTypeIds=${vehicleTypeIds.join(',')}`;
            }

            const reportsData = await apiCall({
                url,
                method: "get",
                token: localStorage.getItem("token"),
            });
            set({
                commonReportsData: Array.isArray(reportsData) ? reportsData : [],
                loading: false
            });

        } catch (error) {
            console.log(error.response?.data?.message || "Error fetching data");
            if (error.response && error.response.status === 404) {
                set({
                    commonReportsData: [], // fixed typo: commonReportsData → commonReportsData
                    error: "No Data found.",
                    loading: false
                });
            } else {
                set({ error: error.response?.data?.message || "Something went wrong", loading: false });
            }
        }
    },
}));

export default CommonApiStore
